import React from 'react'
import {useTranslation} from '@modifi/plugin-i18n'
import {Col, Strong, Small, ButtonLink, AttentionIcon, Row, Caption} from '@modifi/ui'
import {landGreen} from '@modifi/colors'

import {BannerWrapper} from './styles'

type FormDataChangedBannerProps = {
  isVisible: boolean
  onDiscard: () => void
  onKeep: () => void
}

/** Tells the user that data they have unsaved changes for was updated by the admin team */
const FormDataChangedBanner: React.FC<FormDataChangedBannerProps> = ({
  isVisible,
  onDiscard,
  onKeep,
}) => {
  const {t} = useTranslation('charon')

  if (!isVisible) {
    return null
  }

  return (
    <BannerWrapper data-ident="form-data-changed-banner" role="alert">
      <Row alignItems="start" mb={8}>
        <Col auto>
          <AttentionIcon width={20} height={20} color={landGreen} />
        </Col>
        <Col col>
          <Strong>
            <Small>{t('company-lock-status.form-data-changed-banner.title')}</Small>
          </Strong>
        </Col>
      </Row>
      <Caption>{t('company-lock-status.form-data-changed-banner.message')}</Caption>
      <Row justifyContent="between" mt={8}>
        <Col auto>
          <ButtonLink
            type="button"
            data-target="form-data-changed-banner-discard"
            onClick={onDiscard}
          >
            {t('company-lock-status.form-data-changed-banner.discard.cta')}
          </ButtonLink>
        </Col>
        <Col auto>
          <ButtonLink type="button" data-target="form-data-changed-banner-keep" onClick={onKeep}>
            {t('company-lock-status.form-data-changed-banner.keep.cta')}
          </ButtonLink>
        </Col>
      </Row>
    </BannerWrapper>
  )
}

export default FormDataChangedBanner
